const mobileAppAnimation = (interval: number): void => {
  const $appSlides = document.querySelectorAll<HTMLDivElement>('[data-mobile-app-slide]')
  if ($appSlides.length) {
    let loopCounter = 0
    $appSlides[loopCounter].classList.add('active')
    setInterval(() => {
      $appSlides[loopCounter].classList.remove('active')
      loopCounter = loopCounter >= $appSlides.length - 1 ? 0 : loopCounter + 1
      $appSlides[loopCounter].classList.add('active')
    }, interval)
  }
}

export const initMobileAppSlider = (): void => {
  const LOOP_TICK_TIME = 1800
  mobileAppAnimation(LOOP_TICK_TIME)
}
